// navigation.ts — maps sidebar nav ids (from chrome) to routes, and resolves the
// active nav id from the current pathname.

export const NAV_ROUTES: Record<string, string> = {
  // Inventory (reference module) — real routes.
  dashboard: '/inventory',
  products: '/inventory/products',
  batches: '/inventory/batches',
  locations: '/inventory/locations',
  adjustments: '/inventory/adjustments',
  reconciliation: '/inventory/reconciliation',
  alerts: '/inventory/alerts',
  importexport: '/inventory/import-export',
  // Master Data — real routes.
  'md-home': '/master-data',
  'md-products': '/master-data/catalog',
  'md-bins': '/master-data/bins',
  'md-storetypes': '/master-data/store-types',
  'md-bintypes': '/master-data/bin-types',
  'md-stores': '/master-data/stores',
  'md-devices': '/master-data/devices',
  'md-manufacturers': '/master-data/manufacturers',
  'md-storagerules': '/master-data/policies',
  'md-workflow': '/master-data/workflow',
  'md-dispense-locations': '/master-data/dispense-locations',
  'md-tray-master': '/master-data/tray-master',
  'md-stations': '/master-data/stations',
  'md-labels': '/master-data/labels',
  'md-policies': '/master-data/policies',
  'md-rbac': '/master-data/rbac',
  'md-modulesettings': '/master-data/settings',
  'md-import': '/master-data/import',
  // Stocks — real routes.
  'stk-dashboard': '/stocks',
  'stk-inward': '/stocks/inward',
  'stk-transfers': '/stocks/transfers',
  'stk-adjustments': '/stocks/adjustments',
  'stk-returns': '/stocks/returns',
  'stk-otc': '/stocks/otc',
  'stk-import': '/stocks/import',
  'stk-reports': '/stocks/reports',
  // Dispensing (stock outward) — tabbed hub.
  'disp-home': '/dispensing',
  // The Dispense Queue IS the unified workflow board (all statuses, arrival → posted).
  'disp-queue': '/workflow',
  'disp-trays': '/dispensing/trays',
  'disp-capacity': '/dispensing/tray-capacity',
  'disp-locations': '/dispensing/locations',
  'disp-backorders': '/dispensing/backorders',
  'disp-partpacks': '/dispensing/partpacks',
  // Prescriptions — real routes.
  'rx-dashboard': '/prescriptions',
  'rx-patients': '/prescriptions/patients',
  'rx-manual': '/prescriptions/manual',
  'rx-ocr': '/prescriptions/ocr',
  // Multi-Store — real routes.
  'mst-dashboard': '/multistore',
  'mst-stock': '/multistore/stock',
  'mst-overstock': '/multistore/overstock',
  'mst-requests': '/multistore/requests',
  'mst-tracking': '/multistore/tracking',
  'mst-discrepancies': '/multistore/discrepancies',
  'mst-history': '/multistore/history',
  compliance: '/compliance',
  // Account pages (accessed from topbar popover)
  __profile: '/profile',
  __account: '/account',
};

export function navPath(id: string): string {
  return NAV_ROUTES[id] ?? '/inventory';
}

/** Resolve the active nav id from a pathname (longest matching route wins). */
export function activeNav(pathname: string): string {
  let bestId = 'dashboard';
  let bestLen = -1;
  for (const [id, path] of Object.entries(NAV_ROUTES)) {
    if ((pathname === path || pathname.startsWith(path + '/')) && path.length > bestLen) {
      bestId = id;
      bestLen = path.length;
    }
  }
  return bestId;
}
